export default __webpack_public_path__ + "static/media/vv_logo_sv.37e3f3a8.png";